import { FASTSHIFT_PATHS, FASTSHIFT_PATH_KEYS } from "./constants";

export const getDomainScopedPathKeys = () =>
    Object.keys(FASTSHIFT_PATHS).filter((pathKey) =>
        FASTSHIFT_PATHS[pathKey as FASTSHIFT_PATH_KEYS].includes(":domainId")
    );

export const removeTrailingSlash = (url: string): string =>
    url.replace(/\/+$/, "");
